$(document).ready(function() {
 if($(window).width() < 749){
    $(document).on("click",".sidebar_grid .menu h3",function(){
      $(this).closest('.menu').find('.sidebar-lists').slideToggle();
      $(this).toggleClass('active');
    });
  }

  var maxDate = year + '-' + month + '-' + day;
    $('#start').attr('min', maxDate);
    var dtToday = new Date();
    var month = dtToday.getMonth() + 1;
    var day = dtToday.getDate();
    var year = dtToday.getFullYear();
    if(month < 10)
        month = '0' + month.toString();
    if(day < 10)
        day = '0' + day.toString();
    var maxDate = year + '-' + month + '-' + day;
    $('#start').attr('min', maxDate);
    $(document).on("change","#start",function(){
      var dateSelected = $(this).val();
      $('#dataSelected').val(dateSelected);
    });
  
  $(document).on("click",".text--faq",function(){
    var dataid = $(this).attr("data-linked-id");
    console.log(dataid)
    $("html,body").animate({scrollTop:$(dataid).offset().top},"slow")
  });
  $(document).on('click','.addon_title',function(){
    if($(this).next(".addon_products_grids").hasClass('hiddenslider')){
      $(this).next(".addon_products_grids").removeClass('hiddenslider')
      $(this).next(".addon_products_grids").fadeIn();
    }else{
    if($(this).next(".addon_products_grids").is(':visible')){
      $(this).next(".addon_products_grids").fadeOut();
    }else{
        $(".addon_products_grids").fadeOut();
        $(this).next(".addon_products_grids").fadeIn();
    }
    }
  });

  $(document).on('click','.addon_close',function(){
    $(this).closest('.addon_products').find('.addon_products_grids').fadeOut();
  });

  var divs = $(".addon-slider .addon_product_grid");
  for(var i = 0; i < divs.length; i+=3) {
    divs.slice(i, i+3).wrapAll("<div class='addon_gridslider'></div>");
  }
  
  setTimeout(function(){
    $('.addon-slider .addon_products_gridsInner').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots:true
    });
  },1000);
  
});